import * as React from 'react';

import QuickReplyTemplatesStore from './QuickReplyTemplatesStore';
import {
  QuickReplyTemplatesStoreContext,
  QuickReplyTemplatesStoreProvider
} from './context';

const useQuickReplyTemplatesStore = (): QuickReplyTemplatesStore => {
  const quickReplyTemplatesStoreContext = React.useContext(
    QuickReplyTemplatesStoreContext
  );

  return quickReplyTemplatesStoreContext.store as QuickReplyTemplatesStore;
};

export {
  QuickReplyTemplatesStore,
  useQuickReplyTemplatesStore,
  QuickReplyTemplatesStoreProvider
};
